var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreamlinedHrProcesse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 70.404 73.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20566",
    "data-name": "Group 20566",
    transform: "translate(-4.872 -3.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36271",
    "data-name": "Path 36271",
    d: "M61.257,53.637C68.1,37.195,59.985,17.074,43.662,9.957a1.3,1.3,0,0,0-1.075,2.371A31.511,31.511,0,0,1,58.922,52.474a6.053,6.053,0,1,0,2.335,1.164ZM57.487,61.8a3.455,3.455,0,1,1,3.455-3.455A3.455,3.455,0,0,1,57.487,61.8Z",
    transform: "translate(10.98 1.747)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36272",
    "data-name": "Path 36272",
    d: "M7.63,46.93c2.1-.183.983-2.795,1.179-4.164a31.515,31.515,0,0,1,26.243-31.03A6.041,6.041,0,0,0,46.9,10.043C46.759,2.63,36.134,1.824,34.878,9.1A34.189,34.189,0,0,0,6.336,45.741,1.3,1.3,0,0,0,7.63,46.93ZM40.84,6.589a3.455,3.455,0,1,1-3.455,3.455A3.455,3.455,0,0,1,40.84,6.589Z",
    transform: "translate(0.25)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36273",
    "data-name": "Path 36273",
    d: "M58.256,57.609a31.475,31.475,0,0,1-42.3-6.4,6.028,6.028,0,1,0-2.092,1.547,34.07,34.07,0,0,0,45.856,7,1.3,1.3,0,1,0-1.464-2.15ZM7.985,47.215A3.455,3.455,0,1,1,11.44,50.67a3.455,3.455,0,0,1-3.455-3.455Z",
    transform: "translate(0 11.202)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36274",
    "data-name": "Path 36274",
    d: "M36.059,19.111C27.806,19,23.2,29.148,28.643,35.251A17.87,17.87,0,0,0,18.558,48.485a3.61,3.61,0,0,0,3.533,4.172H50.025a3.614,3.614,0,0,0,3.546-4.172,17.917,17.917,0,0,0-10.1-13.233c5.443-6.1.838-16.262-7.415-16.142Zm0,2.6c9.486.3,9.485,14.056,0,14.356-9.487-.3-9.483-14.056,0-14.356ZM51,48.906a.966.966,0,0,1-.976,1.149H22.091a.962.962,0,0,1-.742-.346.978.978,0,0,1-.222-.8A15.218,15.218,0,0,1,30.87,37.167a9.7,9.7,0,0,0,10.377,0A15.257,15.257,0,0,1,51,48.906Z",
    transform: "translate(3.957 4.539)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlinedHrProcesse);
export default __webpack_public_path__ + "static/media/streamlined-hr-processe.432762d44bedffa9bca984fe601daf4c.svg";
export { ForwardRef as ReactComponent };